module.exports = __webpack_public_path__ + "static/media/Welcome Letter.25a74b95.svg";